import { render, staticRenderFns } from "./ExpiredVoucherTemplate.vue?vue&type=template&id=7cfaec0c&scoped=true"
import script from "./ExpiredVoucherTemplate.vue?vue&type=script&lang=js"
export * from "./ExpiredVoucherTemplate.vue?vue&type=script&lang=js"
import style0 from "./ExpiredVoucherTemplate.vue?vue&type=style&index=0&id=7cfaec0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfaec0c",
  null
  
)

export default component.exports